import React from 'react'
import PropTypes from 'prop-types'
import ImagePin from '@aytm/lib/rfd-ui/components/basic/image-pin'
import ImagePreview from '@aytm/app/survey/editor/components/content/assets/ImagePreview'
import Popup from '@aytm/lib/rfd-ui/components/basic/popup'
import { PureDataComponent } from '@aytm/lib/common/components/pure-component'

import '@aytm/lib/rfd-ui/styles/swidget/image-item.scss'
import { SwidgetImage } from '@aytm/app/swidget/questions/components/common/swidget-image'

export default class ImageItem extends PureDataComponent {
  static propTypes = {
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    baseURL: PropTypes.string.isRequired,
    previewURL: PropTypes.string.isRequired,
    direction: PropTypes.string.isRequired,
    isMobile: PropTypes.bool,
    scrolling: PropTypes.bool
  }

  render() {
    const { width, direction, isMobile, scrolling, inFrame, picture, imageCallback } = this.props

    return (
      <div className={`rfd-ui-image-item${isMobile ? ' mobile' : ''}`} style={{ width }}>
        {isMobile ? (
          <ImagePin
            scrolling={scrolling}
            withPopup={true}
            baseURL={picture.get('original_url')}
            width={width}
            previewURL={picture.get('big_thumbnail_path')}
          />
        ) : !inFrame ? (
          <Popup
            portal={true}
            width="250px"
            trigger="hover"
            direction={direction}
            hideOtherPopupsOnShow={true}
            content={() => (
              <ImagePreview
                allowScrolling={scrolling}
                maxHeight="480px"
                imageUrl={picture.get('original_url')}
                previewUrl={picture.get('big_thumbnail_path')}
              />
            )}
            contentTheme="thin-black"
          >
            <img src={picture.get('big_thumbnail_path')} className="rfd-ui-thumbnail" />
          </Popup>
        ) : (
          <SwidgetImage picture={picture} theme="desktop" inFrame={inFrame} imageCallback={imageCallback} />
        )}
      </div>
    )
  }
}
